import { Button, Popover, PopoverTrigger, PopoverContent, Input } from '@repo/ui-web';

export function PopoverShowcase() {
  return (
    <div className="space-y-6">
      <div className="space-y-3">
        <p className="text-sm font-semibold text-foreground">Basic</p>
        <Popover>
          <PopoverTrigger asChild>
            <Button variant="outline" size="sm">
              Open popover
            </Button>
          </PopoverTrigger>
          <PopoverContent className="w-80">
            <div className="space-y-2">
              <h4 className="text-sm font-medium text-foreground">Dimensions</h4>
              <p className="text-xs text-muted-foreground">Set the dimensions for the layer.</p>
              <div className="grid grid-cols-2 gap-2">
                <div className="space-y-1">
                  <label className="text-xs text-muted-foreground">Width</label>
                  <Input defaultValue="100%" />
                </div>
                <div className="space-y-1">
                  <label className="text-xs text-muted-foreground">Height</label>
                  <Input defaultValue="25px" />
                </div>
              </div>
            </div>
          </PopoverContent>
        </Popover>
      </div>

      <div className="space-y-3">
        <p className="text-sm font-semibold text-foreground">Placement</p>
        <div className="flex flex-wrap gap-2">
          {(['top', 'right', 'bottom', 'left'] as const).map((side) => (
            <Popover key={side}>
              <PopoverTrigger asChild>
                <Button variant="secondary" size="sm">
                  {side}
                </Button>
              </PopoverTrigger>
              <PopoverContent side={side} className="w-48">
                <p className="text-sm text-foreground">
                  Popover on the <strong>{side}</strong>.
                </p>
              </PopoverContent>
            </Popover>
          ))}
        </div>
      </div>
    </div>
  );
}
